import { broker } from "./broker.config";

export const siteConfig = {
  appName: "Path Financial Solutions",
  author: broker.name,
  description:
    "Your local mortgage broker in Springfield, Brisbane, Logan & Ipswich. Access 70+ lenders for home loans, refinancing, first home buyer help & investment properties. Free service, expert guidance.",
  shortDescription:
    "Mortgage broker in Springfield, Brisbane & South East Queensland. Expert home loan guidance with access to 70+ lenders.",
  keywords: [
    "mortgage broker Springfield",
    "mortgage broker Brisbane",
    "mortgage broker Logan",
    "mortgage broker Ipswich",
    "home loans Springfield Lakes",
    "home loans Spring Mountain",
    "first home buyer Springfield",
    "refinancing Brisbane",
    "investment property loan QLD",
    "mortgage broker near me",
    "home loan broker South East Queensland",
    "Springfield Central mortgage",
    "best home loan rates Brisbane",
  ],
  serviceAreas: [
    "Springfield",
    "Springfield Lakes",
    "Spring Mountain",
    "Springfield Central",
    "Brisbane",
    "Logan",
    "Ipswich",
    "Greater Springfield",
    "South East Queensland",
  ],
  url: "https://pathfinancial.com.au",
  logo: "/logo/official-logo.jpg",
  ogImage: "/og-image.png",
  business: {
    acl: "389087",
    aclProvider: "AFG",
    abn: "97 184 515 627",
    phone: broker.phone,
    email: broker.email,
    address: "",
  },
  socials: {
    facebook: broker.socials?.facebook || "",
    linkedin: broker.socials?.linkedin || "",
    instagram: "",
  },
  legal: {
    privacyPolicy: "/privacy-policy",
    termsConditions: "/terms-conditions",
    complaints: "/complaints",
  },
} as const;

export type SiteConfig = typeof siteConfig;
